var _circle, _path, _path2, _g, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilestoneCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_866_225)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 32.25C38 30.4551 39.3431 29 41 29C42.6569 29 44 30.4551 44 32.25V38.75C44 40.5449 42.6569 42 41 42C39.3431 42 38 40.5449 38 38.75V32.25Z",
    fill: "#393184"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 32.25C56 30.4551 57.3431 29 59 29C60.6569 29 62 30.4551 62 32.25V38.75C62 40.5449 60.6569 42 59 42C57.3431 42 56 40.5449 56 38.75V32.25Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_866_225)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 34,
    width: 36,
    height: 36,
    fill: "url(#paint1_linear_866_225)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 34,
    width: 36,
    height: 36,
    stroke: "url(#paint2_linear_866_225)",
    strokeWidth: 0.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8113 48.563C42.9009 47.3854 43.3553 46.4638 44.1745 45.7982C44.9937 45.1326 46.0561 44.7998 47.3617 44.7998C48.2321 44.7998 48.9809 44.9598 49.6081 45.2798C50.2481 45.587 50.7281 46.0094 51.0481 46.547C51.3809 47.0846 51.5473 47.6926 51.5473 48.371C51.5473 49.1646 51.3169 49.8494 50.8561 50.4254C50.4081 51.0014 49.8193 51.3726 49.0897 51.539V51.635C49.9217 51.8398 50.5809 52.243 51.0673 52.8446C51.5537 53.4462 51.7969 54.2334 51.7969 55.2062C51.7969 55.9358 51.6305 56.595 51.2977 57.1838C50.9649 57.7598 50.4657 58.2142 49.8001 58.547C49.1345 58.8798 48.3345 59.0462 47.4001 59.0462C46.0433 59.0462 44.9297 58.6942 44.0593 57.9902C43.1889 57.2734 42.7025 56.2622 42.6001 54.9566H44.2897C44.3793 55.7246 44.6929 56.3518 45.2305 56.8382C45.7681 57.3246 46.4849 57.5678 47.3809 57.5678C48.2769 57.5678 48.9553 57.3374 49.4161 56.8766C49.8897 56.403 50.1265 55.795 50.1265 55.0526C50.1265 54.0926 49.8065 53.4014 49.1665 52.979C48.5265 52.5566 47.5601 52.3454 46.2673 52.3454H45.8257V50.8862H46.2865C47.4641 50.8734 48.3537 50.6814 48.9553 50.3102C49.5569 49.9262 49.8577 49.3374 49.8577 48.5438C49.8577 47.8654 49.6337 47.3214 49.1857 46.9118C48.7505 46.5022 48.1233 46.2974 47.3041 46.2974C46.5105 46.2974 45.8705 46.5022 45.3841 46.9118C44.8977 47.3214 44.6097 47.8718 44.5201 48.563H42.8113Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6951 46.6622V45.0686H57.3047V58.9502H55.5383V46.6622H53.6951Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_866_225",
    x: 29.85,
    y: 31.85,
    width: 40.3,
    height: 40.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_866_225"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_866_225",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_866_225",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_866_225",
    x1: 35.8524,
    y1: 37.3214,
    x2: 74.7096,
    y2: 57.4412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_866_225",
    x1: 53,
    y1: 40,
    x2: 66.5,
    y2: 71.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneCalender);
export default __webpack_public_path__ + "static/media/milestone-calender.058d0e206f7a1e09a0eb374ab29490e6.svg";
export { ForwardRef as ReactComponent };